export const weights = {
  normal: 'font-normal',
  semibold: 'font-semibold',
  medium: "font-medium",
  light:'font-light'
};
